import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  selectedTabIndex: number;
};

const initialState: StateInterface = {
  selectedTabIndex: 0
};

export const contactsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_CONTACTS_SWITCH_TAB:
      return {...state,
        selectedTabIndex: action.payload?.index
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
